export interface Source {
    value: number;
    type: string;
}

export const flowSources: Source[]  = [{ value: 0, type: 'NewDocument'},
                                       { value: 1, type: 'ExistingDocument'}];



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/interfaces/flowSources.interface.ts